module.exports = __webpack_public_path__ + "static/media/programming-plc-languages400x200.6dd8817a.jpg";